export const MonsterExistElement =  ()=>{
    return (
        <div className="container">
            カードが有無はフィールドにカードがあるかどうかを示します。選択のときに使用します。フィールドに存在するカードを選ぶときはカード有無にチェックをカードが存在しない場所を選ぶ場合はチェックを外します
            <p><img src={`${process.env.PUBLIC_URL}/dialogbox_monster_exist.png`}></img></p>
        </div>
    )
}
